<div class="jobseeker-workexperience">
  <h3>
    {{ 'label.WorkExperience' | translate }}
    <span class="total-experience">
      &nbsp; &nbsp; &nbsp; &nbsp;
      <span *ngIf="jobseeker && jobseeker.totalWorkExperienceYears > 0"
        >{{ jobseeker.totalWorkExperienceYears }} {{ 'label.Year' | translate }}
      </span>
      <span *ngIf="jobseeker && jobseeker.totalWorkExperienceMonths > 0"
        >{{ jobseeker.totalWorkExperienceMonths }}
        {{ 'label.Month' | translate }}</span
      >
    </span>
  </h3>
  <div class="divider"></div>
  <hr-jobseeker-work-experience-item
    *ngFor="let item of jobseeker?.workExperiences"
    [workExperience]="item"
    (onUpdate)="onWorkExperienceUpdate($event)"
  ></hr-jobseeker-work-experience-item>
  <br />
  <div
    *ngIf="
      jobseeker &&
      jobseeker.totalWorkExperienceYears == 0 &&
      jobseeker.totalWorkExperienceMonths == 0 &&
      jobseeker.workExperiences?.length == 0 &&
      jobseeker.isWorkExperienceFilled
    "
    class="without-experience"
  >
    {{ 'label.WithoutExperience' | translate }}
  </div>

  <button
    class="fa fa-plus btn btn-default"
    (click)="onAddWorkExperienceClick()"
    *ngIf="!isWorkExperienceAddModeOn && !isWorkExperienceEditModeOn"
  >
    &nbsp;{{ 'label.Add' | translate }}
  </button>
  <button
    class="btn btn-default"
    *ngIf="!jobseeker?.isWorkExperienceFilled"
    (click)="onWithouExperienceClick()"
  >
    {{ 'label.WithoutExperience' | translate }}
  </button>
  <hr-work-experience-editor
    *ngIf="isWorkExperienceAddModeOn"
    [workExperience]="newWorkExperience"
    (onUpdate)="onWorkExperienceUpdate($event)"
    (onCancelEdit)="onWorkExperienceCancel($event)"
  ></hr-work-experience-editor>
</div>
